<style scoped>
.msg-wrapper {
    background: rgb(255, 230, 160);
    background: linear-gradient(
        0deg,
        rgba(255, 230, 160, 1) 0%,
        rgba(255, 249, 235, 1) 100%
    );
}

::v-deep .bubble {
    @apply w-full;
}
</style>

<template>
    <div class="lg:my-4 lg:px-4 lg:border lg:border-gray-300">
        <div class="msg-wrapper flex flex-col -mx-4">
            <img :src="friendInvitationImg" class="w-full" />
        </div>
        <div class="mt-6">
            <div class="font-black">
                Family and Friends「親友會員」 4人同行 一同歡樂
            </div>
            <div class="flex flex-col mt-4 lg:flex-row">
                <contentBlock class="lg:w-5/12 lg:pr-4">
                    <div>
                        為令更多人可以享受到「試吓啦」嘅開心購物平台，我哋決定將歡樂帶畀會員嘅family
                        and
                        friends啦！各「試吓啦」會員可推薦3名親友加入「試吓啦」成為「親友會員」，等他們可以直接享受依個平台嘅愉快購物體驗！
                    </div>
                    <div class="mt-4">
                        活動細則如下：
                    </div>
                    <ul class="mt-4">
                        <li>每位「試吓啦」會員只可邀請3名親友。</li>
                        <li>會員可自行移除親友會員身份。</li>
                        <li>
                            透過Family and
                            Friends登記的「親友會員」不會享有T-coins獎賞計劃
                        </li>
                        <li>
                            親友會員在每個快閃推廣期內最多選擇10款產品，每款產品最多可購買2件(以購物頁面顯示作準)。
                        </li>
                        <li>
                            親友會員如能夠介紹5位公司同事登記加入「試吓啦」，該會員及其公司同事可升級為公司會員。詳情請與我們聯絡。
                        </li>
                        <li>
                            親友會員所訂購的物品只會送到介紹人的指定送貨地址。
                        </li>
                        <li>「試吓啦」保留最終決定權。</li>
                    </ul>
                    <!-- <div class="text-sm mt-8">
                        * 親友會員可購買的產品數量可能與您不相同，詳情請參閱
                        <router-link to="termsOfUse">
                            使用條款
                        </router-link>
                    </div> -->
                </contentBlock>
                <div
                    class="mt-8 lg:mt-0 lg:w-7/12 lg:border-l lg:border-gray-400 lg:px-4"
                >
                    <div v-if="!!loading" class="flex">
                        <spinner class="mx-auto" />
                    </div>
                    <template v-if="!loading">
                        <div v-if="!!friends.length">
                            <div class="font-bold lg:font-normal">
                                已邀請的親友：
                            </div>
                            <table class="block w-full">
                                <thead
                                    class="hidden lg:block leading-tight border-b border-gray-300"
                                >
                                    <tr class="flex w-full">
                                        <th
                                            class="block w-1/5 py-2 font-bold text-left"
                                        >
                                            姓名
                                        </th>
                                        <th
                                            class="block w-1/5 py-2 font-bold text-left"
                                        >
                                            暱稱
                                        </th>
                                        <th
                                            class="block w-1/5 py-2 font-bold text-left"
                                        >
                                            邀請狀況
                                        </th>
                                        <th
                                            class="block flex-1 py-2 font-bold text-left"
                                        >
                                            取貨地點
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="block w-full">
                                    <template v-for="(f, fi) in friends">
                                        <tr
                                            :key="fi"
                                            class="block clearfix my-4 p-4 border border-primary lg:border-0 lg:flex lg:flex-row lg:m-0 lg:py-4 lg:px-0"
                                        >
                                            <td
                                                class="block lg:table-cell lg:w-1/5 lg:py-2"
                                            >
                                                {{ f.fullName }}
                                            </td>
                                            <td
                                                class="block lg:table-cell lg:w-1/5 lg:py-2"
                                            >
                                                {{ f.nickname }}
                                            </td>
                                            <td
                                                class="block lg:table-cell lg:w-1/5 lg:py-2"
                                            >
                                                {{
                                                    f.stsCode === 'I'
                                                        ? '邀請中'
                                                        : '已成為會員'
                                                }}
                                            </td>
                                            <td
                                                class="block lg:table-cell lg:flex-1 lg:py-2"
                                            >
                                                <div
                                                    class="flex justify-between"
                                                >
                                                    <select
                                                        v-if="f.stsCode === 'A'"
                                                        class="form-select w-32 flex-1 py-1"
                                                        v-model="f.cmpySiteKey"
                                                        @change="
                                                            companySiteKeyChange(
                                                                $event,
                                                                f
                                                            )
                                                        "
                                                        :disabled="
                                                            f._updateCmpySiteStatus ===
                                                                'loading'
                                                        "
                                                    >
                                                        <option
                                                            disabled
                                                            :value="null"
                                                        ></option>
                                                        <option
                                                            v-for="s in companySiteList"
                                                            :key="s.id"
                                                            :value="s.id"
                                                        >
                                                            {{ s.cmpySiteName }}
                                                        </option>
                                                    </select>
                                                    <div v-else>
                                                        ------
                                                    </div>
                                                    <loadingButton
                                                        class="px-4 py-1 ml-2 rounded bg-green text-white hover:opacity-75"
                                                        :status="
                                                            f._deleteStatus
                                                        "
                                                        @click="
                                                            requestConfirmDeleteFriend(
                                                                f
                                                            )
                                                        "
                                                    >
                                                        移除
                                                    </loadingButton>
                                                </div>
                                                <errorBox
                                                    v-if="f._deleteErrors"
                                                    class="m-0"
                                                    :message="
                                                        f._deleteErrors.server
                                                    "
                                                />
                                            </td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!friends.length" class="text-center">
                            仲未邀請親友，快啲邀請好友或家⼈加入「試吓啦」
                        </div>
                        <div
                            class="w-full flex mt-4"
                            v-if="!isReachMaxFriendAmount"
                        >
                            <button
                                class="btn btn-primary mx-auto px-10"
                                @click="showAddFriendModal = true"
                            >
                                邀請親友
                            </button>
                            <errorBox :message="errors.server" />
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <modal
            v-if="selectedFriend"
            type="confirm"
            class="modal-secondary"
            :cancelText="$t('common.cancel')"
            :confirmText="$t('common.confirm')"
            @cancel="() => (selectedFriend = undefined)"
            @confirm="voidFriend"
        >
            <div>
                要 取消/刪除 此親友會員?
            </div>
        </modal>
        <inviteFriendFormModal
            v-if="showAddFriendModal"
            @success="loadAllFriends"
            @hide="showAddFriendModal = false"
        />
    </div>
</template>

<script>
import { instance } from '../../utils/ajax';
import img1s112 from '../../assets/img/1-112.png';
import contentBlock from '../../components/contentBlock.vue';
import errorBox from '../../components/errorBox.vue';
import modal from '../../components/modal.vue';
import loadingButton from '../../components/loadingButton.vue';
import spinner from '../../components/spinner.vue';
import inviteFriendFormModal from '../../components/inviteFriendFormModal.vue';
import friendInvitationImg from '../../assets/img/friend_invitation_banner.png';

async function getAllFriends() {
    try {
        const result = await instance.get('/api/friendAccount/getAllFriends');
        return result.data.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error getting all friends');
    }
    return undefined;
}

async function updateFriendCmpySite(friend, cmpySiteKey) {
    try {
        const result = await instance.post(
            '/api/friendAccount/updateFriendCmpySite',
            {
                frndCustKey: friend.id,
                cmpySiteKey
            }
        );
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error update friend company site');
        return { success: false, all: 'error.connect' };
    }
}

async function voidFriend(friend) {
    try {
        const url = `/api/friendAccount/${
            friend.stsCode === 'A'
                ? 'voidFriendAccount'
                : 'voidFriendInvitation'
        }`;

        const result = await instance.post(url, friend);
        return result.data;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error void friend account');
        return { success: false, all: 'error.connect' };
    }
}

export default {
    components: {
        contentBlock,
        errorBox,
        modal,
        loadingButton,
        spinner,
        inviteFriendFormModal
    },
    data() {
        return {
            errors: {},
            loading: false,
            selectedFriend: undefined,
            friends: [],
            isReachMaxFriendAmount: true,
            img1s112,
            showAddFriendModal: false,
            friendInvitationImg
        };
    },
    computed: {
        companySiteList() {
            return this.$store.state.companySiteList || [];
        }
    },
    async mounted() {
        this.loadAllFriends();
    },
    methods: {
        async loadAllFriends() {
            this.loading = true;
            const result = await getAllFriends();
            if (result) {
                this.friends = result.friends.map(f => ({
                    ...f,
                    _deleteStatus: undefined,
                    _deleteErrors: undefined,
                    _updateCmpySiteStatus: undefined
                }));
                this.isReachMaxFriendAmount = result.isReachMaxFriendAmount;
            } else {
                this.friends = [];
                this.isReachMaxFriendAmount = true;
            }
            this.loading = false;
        },
        requestConfirmDeleteFriend(friend) {
            this.selectedFriend = friend;
        },
        async voidFriend() {
            const friend = this.selectedFriend;
            this.selectedFriend = undefined;

            friend._deleteStatus = 'loading';
            const result = await voidFriend(friend);
            if (result.success) {
                friend._deleteStatus = 'success';
                this.loadAllFriends();
            } else {
                friend._deleteStatus = undefined;
                friend._deleteErrors = result.data.errors;
            }
        },
        async companySiteKeyChange(event, friend) {
            const cmpySiteKey = parseInt(event.target.value);
            if (!cmpySiteKey || friend?.stsCode !== 'A') {
                return;
            }

            friend._updateCmpySiteStatus = 'loading';
            const result = await updateFriendCmpySite(friend, cmpySiteKey);
            if (result.success) {
                friend._updateCmpySiteStatus = 'success';
                await new Promise(rs => setTimeout(rs, 1000));
                friend._updateCmpySiteStatus = undefined;
            } else {
                friend._updateCmpySiteStatus = undefined;
            }
        }
    }
};
</script>
